import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=2c906ffc&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=2c906ffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c906ffc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c906ffc')) {
      api.createRecord('2c906ffc', component.options)
    } else {
      api.reload('2c906ffc', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=2c906ffc&scoped=true&", function () {
      api.rerender('2c906ffc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21Row70tTVJJW/JS/comp/DateRangeExt.vue"
export default component.exports